// extracted by mini-css-extract-plugin
module.exports = {"container":"Rule_container__nUjpT","tableContainer":"Rule_tableContainer__2GH0r"};